const eq = (a, b) =>
  String(a ?? '').trim().localeCompare(String(b ?? '').trim(), undefined, { sensitivity: 'base' }) === 0;

export default eq;